import React from 'react';
import PropTypes from 'prop-types';
import { DfpAd, ApplicationErrorBoundary } from 'components';
import {
    createGptSizeMapping,
    mapDeviceNameToViewport
} from 'static/script/app/ui/layout/ads/ad-slot-utilities';

const DESKTOP = 'desktop';
const TABLET = 'tablet';
const MOBILE = 'mobile';

const getAdPosision = (index, device) => {
    switch (index) {
        case 1:
            return `mid1-${device}`;
        case 2:
            return `mid2-${device}`;
        case 3:
            return `mid3-${device}`;
        default:
            return `top-${device}`;
    }
};

const canCreateDfpAd = gptData => gptData && gptData.adUnitPath;

/**
 * Helper method for creating DfpAd
 * @param {object} gptData
 * @param {string} device
 * @param {string} adFormats
 * @param {number} index
 */
const buildProps = (gptData, device, adFormats, index, props) => ({
    adContainerClass: 'col-12 px-0',
    className: 'mb-4',
    pageTargeting: gptData.customTargetingParameters,
    sizeMapping: createGptSizeMapping(adFormats, device),
    minViewportWidth: mapDeviceNameToViewport(device)[0],
    maxViewportWidth: mapDeviceNameToViewport(device)[1],
    adUnitPath: gptData.adUnitPath,
    lazyLoad: index === 0 ? false : true,
    slotTargeting: {
        pos: getAdPosision(index, device)
    },
    ...props
});

const DesktopAd = ({ gptData, index, ...props }) =>
    canCreateDfpAd(gptData) ? (
        <ApplicationErrorBoundary>
            <DfpAd
                {...buildProps(gptData, DESKTOP, 'panorama', index, props)}
            />
        </ApplicationErrorBoundary>
    ) : null;

DesktopAd.propTypes = {
    gptData: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
};

const TabletAd = ({ gptData, index, ...props }) =>
    canCreateDfpAd(gptData) ? (
        <ApplicationErrorBoundary>
            <DfpAd {...buildProps(gptData, TABLET, 'panorama', index, props)} />
        </ApplicationErrorBoundary>
    ) : null;

TabletAd.propTypes = {
    gptData: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
};

const MobileAd = ({ gptData, index, ...props }) =>
    canCreateDfpAd(gptData) ? (
        <ApplicationErrorBoundary>
            <DfpAd
                {...buildProps(
                    gptData,
                    MOBILE,
                    'mobile_rectangle,medium_rectangle,mobile_wideboard',
                    index,
                    props
                )}
            />
        </ApplicationErrorBoundary>
    ) : null;

MobileAd.propTypes = {
    gptData: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
};

export { DesktopAd, TabletAd, MobileAd };



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/ads/search-results-ads.jsx